<form *ngIf="showView" [formGroup]="createAuctionForm1" (ngSubmit)="onSubmit()">
  <div class="auction-form-outer">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width">
            <mat-form-field appearance="outline">
              <mat-label>Auction/Sale Code</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter Sale Code"
                formControlName="auctionCode"
                [maxlength]="10"
                required
              />
            </mat-form-field>
            <char-counter
              [control]="createAuctionForm1.controls.auctionCode"
              [maxlength]="10"
            ></char-counter>
            <control-messages
              [isFormSubmitted]="isSubmitted"
              [control]="createAuctionForm1.controls.auctionCode"
            ></control-messages>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width input-with-tooltip">
            <mat-form-field appearance="outline">
              <mat-label>By Order of (Optional)</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter By Order of text"
                [maxlength]="fieldMaxLengthMedium"
                formControlName="byOrderOf"
              />
            </mat-form-field>

            <span
              class="custom-tooltip"
              #tooltip="matTooltip"
              matTooltip="Add alternate text to be displayed in place of By Order Of label"
              [matTooltipPosition]="'above'"
            >
              <img alt="info" src="../assets/images/info.svg" />
            </span>
            <char-counter
              [control]="createAuctionForm1.controls.byOrderOf"
              [maxlength]="fieldMaxLengthMedium"
            ></char-counter>
            <control-messages
              [isFormSubmitted]="isSubmitted"
              [control]="createAuctionForm1.controls.byOrderOf"
            ></control-messages>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width">
            <mat-form-field appearance="outline">
              <mat-label>Title</mat-label>
              <input
                matInput
                type="text"
                placeholder="Add Auction Name"
                formControlName="title"
                [maxlength]="fieldMaxLength100"
                required
              />
            </mat-form-field>
            <char-counter
              [control]="createAuctionForm1.controls.title"
              [maxlength]="fieldMaxLength100"
            >
            </char-counter>
            <control-messages
              [isFormSubmitted]="isSubmitted"
              [control]="createAuctionForm1.controls.title"
            ></control-messages>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width custom-select-option select-with-label">
            <mat-form-field appearance="outline">
              <mat-label>Auction Category</mat-label>
              <mat-select formControlName="auctionCategory" required>
                <mat-option
                  *ngFor="let category of categories"
                  [value]="category.value"
                  >{{ category.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <control-messages
            [isFormSubmitted]="isSubmitted"
            [control]="createAuctionForm1.controls.auctionCategory"
          ></control-messages>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="mat-field-width">
                <label>Tagline *</label>
                <editor
                  [initialValue]="taglineText"
                  (editorData)="
                    editorContent($event, createAuctionForm1.controls.tagline)
                  "
                  [characterLimit]="fieldMaxLengthLonger"
                ></editor>
                <control-messages
                  [isFormSubmitted]="isSubmitted"
                  [control]="createAuctionForm1.controls.tagline"
                ></control-messages>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <div
                class="mat-field-width custom-select-option select-with-label"
              >
                <mat-form-field appearance="outline">
                  <mat-label>Currency</mat-label>
                  <mat-select formControlName="currency" required>
                    <mat-option
                      *ngFor="let currency of currencies"
                      [value]="currency.value"
                      >{{ currency.text }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.currency"
              ></control-messages>
            </div>

            <div class="form-group">
              <div
                class="mat-field-width custom-select-option select-with-label"
              >
                <mat-form-field appearance="outline">
                  <mat-label>Sale Type</mat-label>
                  <mat-select
                    formControlName="saletype"
                    required
                    (selectionChange)="getSaletypeData()"
                  >
                    <mat-option
                      *ngFor="let saletype of saletypes"
                      [value]="saletype.value"
                      >{{ saletype.text }}
                    </mat-option>
                  </mat-select>
                  <mat-hint>{{ saletypeHint }}</mat-hint>
                </mat-form-field>
              </div>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.saletype"
              ></control-messages>
            </div>

            <ng-container *ngIf="isBiddingAtOurPlatform">
              <div class="form-group">
                <div
                  class="mat-field-width custom-select-option select-with-label"
                >
                  <mat-form-field appearance="outline">
                    <mat-label>Bid Increment</mat-label>
                    <mat-select formControlName="bidIncrementTableId" required>
                      <mat-option
                        *ngFor="let Inc of bidIncrementTables"
                        [value]="Inc.value"
                        >{{ Inc.text }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <control-messages
                  [isFormSubmitted]="isSubmitted"
                  [control]="createAuctionForm1.controls.bidIncrementTableId"
                ></control-messages>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width custom-select-option select-with-label">
            <mat-form-field appearance="outline">
              <mat-label>Select Timezone you are in</mat-label>
              <mat-select formControlName="timezone" required>
                <mat-option
                  *ngFor="let timezone of timezones"
                  [value]="timezone.value"
                  >{{ timezone.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <control-messages
            [isFormSubmitted]="isSubmitted"
            [control]="createAuctionForm1.controls.timezone"
          ></control-messages>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <div class="mat-field-width custom-select-option select-with-label">
            <mat-form-field appearance="outline">
              <mat-label>Sale Manager</mat-label>
              <mat-select formControlName="saleManager" required>
                <mat-option
                  *ngFor="let manager of saleManagers"
                  [value]="manager.value"
                  >{{ manager.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <control-messages
            [isFormSubmitted]="isSubmitted"
            [control]="createAuctionForm1.controls.saleManager"
          ></control-messages>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-lg-6">
            <div class="mat-width-mobile">
              <div class="row gutter-14">
                <div class="col-7">
                  <div class="custom-calender">
                    <mat-form-field
                      class="example-full-width"
                      appearance="outline"
                      role="button"
                      (click)="picker.open()"
                    >
                      <mat-label>Start Date</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        placeholder="MM-DD-YYYY"
                        formControlName="startDate"
                        disabled
                        required
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon
                          >calendar_today</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker
                        #picker
                        [disabled]="disableStartTime"
                      ></mat-datepicker>
                    </mat-form-field>
                    <control-messages
                      [isFormSubmitted]="isSubmitted"
                      [control]="createAuctionForm1.controls.startDate"
                    >
                    </control-messages>
                  </div>
                </div>
                <div class="col-5">
                  <div class="custom-timer">
                    <div class="mat-field-width">
                      <mat-form-field appearance="outline">
                        <mat-label>Start Time</mat-label>
                        <input
                          matInput
                          type="text"
                          [ngxTimepicker]="toggleTimepicker"
                          formControlName="startTime"
                          required
                        />
                        <ngx-material-timepicker-toggle
                          [for]="toggleTimepicker"
                        >
                        </ngx-material-timepicker-toggle>
                        <ngx-material-timepicker
                          #toggleTimepicker
                        ></ngx-material-timepicker>
                      </mat-form-field>
                      <control-messages
                        [isFormSubmitted]="isSubmitted"
                        [control]="createAuctionForm1.controls.startTime"
                      >
                      </control-messages>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="mat-width-mobile">
              <div class="row gutter-14">
                <div class="col-7">
                  <div class="custom-calender">
                    <mat-form-field
                      class="example-full-width"
                      appearance="outline"
                      role="button"
                      (click)="picker2.open()"
                    >
                      <mat-label>End Date</mat-label>
                      <input
                        matInput
                        [min]="minDate"
                        [matDatepicker]="picker2"
                        placeholder="MM-DD-YYYY"
                        formControlName="endDate"
                        disabled
                        required
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker2">
                        <mat-icon matDatepickerToggleIcon
                          >calendar_today</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker
                        #picker2
                        [disabled]="disableEndTime"
                      ></mat-datepicker>
                    </mat-form-field>
                    <control-messages
                      [isFormSubmitted]="isSubmitted"
                      [control]="createAuctionForm1.controls.endDate"
                    >
                    </control-messages>
                    <control-messages
                      [isFormSubmitted]="isSubmitted"
                      [control]="createAuctionForm1"
                    ></control-messages>
                  </div>
                </div>
                <div class="col-5">
                  <div class="custom-timer">
                    <div class="mat-field-width">
                      <mat-form-field appearance="outline">
                        <mat-label>End Time</mat-label>
                        <input
                          matInput
                          type="text"
                          [ngxTimepicker]="toggleTimepicker2"
                          formControlName="endTime"
                          required
                        />
                        <ngx-material-timepicker-toggle
                          [for]="toggleTimepicker2"
                        >
                        </ngx-material-timepicker-toggle>
                        <ngx-material-timepicker #toggleTimepicker2>
                        </ngx-material-timepicker>
                      </mat-form-field>
                      <control-messages
                        [isFormSubmitted]="isSubmitted"
                        [control]="createAuctionForm1.controls.endTime"
                      >
                      </control-messages>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4" *ngIf="showStaggerMinAndLotCloses">
            <div class="form-group">
              <div class="custom-checks-square">
                <input
                  type="checkbox"
                  id="stagger"
                  name="check"
                  formControlName="staggerCompletionTime"
                  [checked]="
                    createAuctionForm1.controls.staggerCompletionTime.value
                  "
                  (change)="removeValidation($event)"
                />
                <label for="stagger" class="m-0"
                  >Stagger Auction Completion Time</label
                >
              </div>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.staggerCompletionTime"
              ></control-messages>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4" *ngIf="showStaggerMinAndLotCloses">
            <div class="form-group">
              <div class="d-flex lot-width">
                <mat-form-field appearance="outline">
                  <mat-label>Every lot closes in</mat-label>
                  <input
                    matInput
                    placeholder="Add Value"
                    formControlName="lotClosesIn"
                    [maxlength]="3"
                    required  
                  />
                </mat-form-field>
                <span class="lot-name">Seconds</span>
              </div>
              <char-counter
                [control]="createAuctionForm1.controls.lotClosesIn"
                [maxlength]="3"
              >
              </char-counter>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.lotClosesIn"
              ></control-messages>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4" *ngIf="showStaggerMinAndLotCloses">
            <div class="form-group">
              <div class="d-flex lot-width">
                <mat-form-field appearance="outline">
                  <mat-label>Minutes to extend</mat-label>
                  <input
                    matInput
                    placeholder="Add Value"
                    formControlName="minutesToExtend"
                    [maxlength]="2"
                    required                   
                  />
                </mat-form-field>
                <span class="lot-name">Minutes</span>
              </div>
              <char-counter
                [control]="createAuctionForm1.controls.minutesToExtend"
                [maxlength]="2"
              >
              </char-counter>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.minutesToExtend"
              ></control-messages>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <div class="d-flex lot-width">
                <mat-form-field appearance="outline">
                  <mat-label>Time to show on catalog after close</mat-label>
                  <input
                    matInput
                    placeholder="Add hours after close"
                    formControlName="millisecondsAfterClose"
                  />
                </mat-form-field>
                <span class="lot-name">Hours</span>
              </div>
              <control-messages
                [isFormSubmitted]="isSubmitted"
                [control]="createAuctionForm1.controls.millisecondsAfterClose"
              ></control-messages>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6" *ngIf="isItRedirectLink">
        <div class="form-group">
          <div class="d-flex w-100">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Redirect Link</mat-label>
              <input
                matInput
                placeholder="Add Redirect Link"
                formControlName="redirectLink"
                required
              />
            </mat-form-field>
          </div>
          <control-messages
            [isFormSubmitted]="isSubmitted"
            [control]="createAuctionForm1.controls.redirectLink"
          ></control-messages>
        </div>
      </div>

      <div class="col-12" *ngIf="isItRedirectLink">
        <div class="upload-with-name">
          <div class="custom-file-upload">
            <span class="upload-inner">
              <div *ngIf="coverPhotoString; else showPlaceholder">
                <img
                  alt="thumb-image"
                  class="thumb-image"
                  width="150"
                  [src]="coverPhotoString"
                />
              </div>
              <ng-template #showPlaceholder>
                <img
                  class="thumb-image"
                  src="../assets/images/thumbnail-square.jpg"
                  title="thumb-image"
                  alt="thumb-image"
                />
              </ng-template>
              <img
                src="../assets/images/ic-upload-photo.svg"
                class="upload-btn"
                alt="upload-btn"
                role="button"
                (click)="cover.click()"
              />
            </span>
            <input
              type="file"
              style="display: none"
              [accept]="coverPhotoFormat"
              #cover
              (change)="uploadCoverPhoto($event.target.files)"
            />
          </div>
          <div class="for-info">
            <p class="name">Cover Photo*</p>
            <p class="upload-note m-0">
              Recommended Size : <br class="d-sm-none" />
              1024 * 720 px <br />
              <br class="d-sm-none" />
              File size should not exceed
              {{ +coverPhotoSize / (1024 * 1024) }} MB
            </p>
            <control-messages
              [control]="createAuctionForm1.controls.coverPhoto"
            ></control-messages>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="isItRedirectLink">
        <div class="upload-with-name">
          <div class="custom-file-upload">
            <span class="upload-inner">
              <div
                class="upload-container"
                *ngIf="clientLogoString != null; else showPlaceholder"
              >
                <img
                  alt="thumb-image"
                  class="thumb-image"
                  width="150"
                  [src]="clientLogoString"
                />
              </div>
              <ng-template #showPlaceholder>
                <img
                  class="thumb-image"
                  src="../assets/images/thumbnail-square.jpg"
                  alt="thumb-image"
                  title="thumb-image"
                />
              </ng-template>
              <img
                src="../assets/images/ic-upload-photo.svg"
                class="upload-btn"
                alt="upload-btn"
                role="button"
                (click)="logo.click()"
              />
            </span>
            <input
              type="file"
              style="display: none"
              [accept]="clientLogoFormat"
              #logo
              (change)="uploadClientLogo($event.target.files)"
            />
          </div>

          <div class="for-info">
            <p class="name">Client Logo*</p>
            <p class="upload-note m-0">
              Recommended Size : <br class="d-sm-none" />
              240 * 240 px <br />
              <br class="d-sm-none" />
              File size should not exceed
              {{ +clientLogoSize / (1024 * 1024) }} MB
            </p>
            <control-messages
              [control]="createAuctionForm1.controls.clientLogo"
            ></control-messages>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div
          class="my-2 error-msg"
          *ngIf="createAuctionForm1.invalid && isSubmitted"
        >
          Please resolve error(s) first
        </div>

        <div class="steps-btn-wrap pt-4 mt-2">
          <button
            role="button"
            (click)="gotoAuctionListing()"
            class="btn btn-white-border mr-2"
          >
            Cancel
          </button>

          <ng-container
            *ngIf="
              ![auctionStatuses.past, auctionStatuses.archived].includes(
                currentAuctionStatus
              )
            "
          >
            <button type="submit" class="btn btn-colored">
              {{ isItRedirectLink ? "Send for approval" : "Save & Continue" }}
            </button>
          </ng-container>

          <ng-container
            *ngIf="
              [auctionStatuses.past, auctionStatuses.archived].includes(
                currentAuctionStatus
              )
            "
          >
            <button type="button" class="btn btn-colored" (click)="goToStep()">
              Skip
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
